<template>
    <section class="home_nav">
        <div class="home_nav_header">
            <!-- <img
                src="../../../../../dist/static/img/logo.jpg"
                class="org_logo" /> -->
            <!-- <div
                style="background: url(../../../../../dist/static/img/logo.jpg);"
                class="org_logo"></div> -->
            <div class="home_nav_brand">
                充一点电运营管理平台
            </div>
        </div>
        <div class="home_nav_navbar clearfix">
            <div class="home_nav_navbar_left">

            </div>
            <div class="home_nav_navbar_right">
                <p class="nav_set_up">
                    <el-dropdown
                        :show-timeout="0"
                        placement="bottom">
                        <!-- <img
                            class="nav_user_img"
                            src="static/img/default.jpg" :alt="userName"> -->
                            <div class="nav_user">{{userName}}</div>

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                @click.native="updatePasswordHandle()">修改密码</el-dropdown-item>
                            <el-dropdown-item
                                @click.native="logoutHandle()">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </p>
                <!-- <el-button size="mini" @click="openScreen">去大屏</el-button> -->
            </div>
        </div>
        <!-- 弹窗, 修改密码 -->
        <updatePassword
            v-if="updatePassowrdVisible"
            ref="updatePassowrd"></updatePassword>
    </section>
</template>

<script>
    import navBar from './home.nav.bar.js';

    export default {
        ...navBar
    };
</script>

<style src="./home-nav-bar.css" scoped></style>


// WEBPACK FOOTER //
// src/views/common/home/home-nav-bar/home-nav-bar.vue